import { AdminErrorMessage, EmptyState } from "./AdminState";
import { useApi } from "./useApi";

type AuditLog = {
  id: string;
  actor_email: string;
  action: string;
  entity_type: string;
  entity_id: string;
  created_at: string;
};

export function AdminAuditLogs() {
  const { data, error, status, loading } = useApi<{ audit_logs: AuditLog[] }>(
    "/api/admin/audit-logs",
  );
  const logs = data?.audit_logs ?? [];

  return (
    <section className="rounded-lg border border-line bg-white p-6 shadow-card">
      <div className="mb-6">
        <p className="eyebrow">الإدارة الداخلية</p>
        <h1 className="text-3xl font-bold text-charcoal">سجل التدقيق</h1>
      </div>
      {loading ? <p>جاري التحميل...</p> : null}
      {error ? <AdminErrorMessage error={error} status={status} /> : null}
      {data ? (
        logs.length ? (
          <div className="grid gap-3">
            {logs.map((log) => (
              <div key={log.id} className="rounded-md border border-line bg-offwhite p-4">
                <strong className="text-charcoal">{log.action}</strong>
                <p className="mt-1 text-sm text-ash">
                  {log.actor_email} - {log.entity_type} - {log.entity_id} - {log.created_at}
                </p>
              </div>
            ))}
          </div>
        ) : (
          <EmptyState>لا توجد سجلات تدقيق حالياً.</EmptyState>
        )
      ) : null}
    </section>
  );
}
